module.exports = __webpack_public_path__ + "static/media/workshop_journal.214808cc.svg";